import { FocusTrap } from "@aleksundshantu/aunds-utils-react/accessibility";
import { useModal } from "../ModalRoot/ModalRoot";
import styles from "./ModalContent.module.scss";

interface ModalContentProps {
  children: React.ReactNode;
}

const ModalContent = ({ children }: ModalContentProps) => {
  const { open, setOpen } = useModal();

  return (
    open && (
      <FocusTrap autoFocus>
        {/* eslint-disable-next-line jsx-a11y/no-noninteractive-element-interactions */}
        <div
          role="dialog"
          className={styles["modal-content"]}
          onKeyDown={(e) => {
            if (e.key === "Escape") {
              setOpen(false);
            }
          }}
          onClick={(e) => {
            if (e.target === e.currentTarget) {
              setOpen(false);
            }
          }}
        >
          {children}
        </div>
      </FocusTrap>
    )
  );
};

export default ModalContent;
